/**
 * @ngdoc directive
 * @name editableField.directive:editableFieldInput
 * @description
 *
 */
// @ngInject
module.exports = function (AnalyticsService) {
    return {
        restrict: 'C',
        require: ['?^^editableFieldGroup', '?ngModel'],
        link: function ($scope, $element, attrs, controllers) {
            var previous_content;
            var editable_field_group_controller = controllers[0];
            var model_controller = controllers[1];
            if (editable_field_group_controller && model_controller) {
                $scope.$watch(editable_field_group_controller.getState, function (state, previous_state) {
                    var pageName = window.location.pathname;
                    var formName = $element[0].form.name;
                    var inputName = $element.attr('name');
                    switch (state) {
                    case editable_field_group_controller.EDIT:
                        previous_content = model_controller.$modelValue;
                        AnalyticsService.trackPage([pageName, 'form', formName, inputName, 'edit'].join('/'));
                        break;
                    case editable_field_group_controller.CANCEL:
                        if (model_controller && previous_state) {
                            model_controller.$setViewValue(previous_content, editable_field_group_controller.CANCEL);
                            model_controller.$render();
                            AnalyticsService.trackPage([pageName, 'forms', formName, inputName, 'cancel'].join('/'));
                        }
                        break;
                    case editable_field_group_controller.SAVE:
                        AnalyticsService.trackPage([pageName, 'forms', formName, inputName, 'save'].join('/'));
                        break;
                    }
                });
            }
        }
    };
};
